/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable react/no-danger */
/* eslint-disable no-console */
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import AWS from 'aws-sdk';
import styles from './advisories.module.scss';
import { fetchAirportInfo, fetchRunwayInfo, fetchUsefulLinks } from '../../AirfieldsConditions/components/redux/actions';
import Spinner from '../../../components/spinner';
import { isLocal } from '../../../constants/apiEnv';
import { getS3Region } from '../../../utils/helpers';

const Advisories = ({
  airport,
  airportInfo,
  actionSaveUsefulLinks,
  actionSaveRunwayInfo,
  actionSaveAirportInfo
}) => {
  const [checkEU, setCheckEU] = useState(false);
  const [loading, setLoading] = useState(false);


  const getData = (fileName, code) => {
    if (AWS?.config?.credentials?.expired === false) {
      const s3 = new AWS.S3({
        apiVersion: '2006-03-01',
        region: getS3Region()
      });

      const params = {
        Bucket: `${process.env.REACT_APP_S3PREFIX}${isLocal? 'local' : code}-attachments/conditions`,
        Key: `${fileName}`,
        ResponseCacheControl: 'no-cache'
      };

      new Promise((resolve, reject) => {
        s3.getObject(params, (err, data) => {
          if (err) {
            setLoading(false);
            return reject(err);
          }
          return resolve(data);
        });
      }).then((response) => {
        const info = response.Body.toString();
        actionSaveAirportInfo(info);
        setLoading(false);
      });
    }
  };

  useEffect(() => {
    if (!airportInfo) {
      setLoading(true);
      const docClient = new AWS.DynamoDB.DocumentClient();
      const params = {
        TableName: `${process.env.REACT_APP_PREFIX}airport_info`,
        Key: { id: `${airport.code}_${checkEU ? 'eu' : 'us'}` }
      };
      docClient.get(params).promise().then((data) => {
        if (data.Item) {
          if (data.Item.airportInformation.attachment_name) {
            getData(data.Item.airportInformation.attachment_name, checkEU ? 'eu' : 'us');
          } else {
            actionSaveAirportInfo(data.Item.airportInformation.airport_information);
          }
          actionSaveRunwayInfo(data.Item.runwayConditions);
          actionSaveUsefulLinks(data.Item.usefulLinks);
          setLoading(false);
        } else if (checkEU === true) {
          setLoading(false);
        } else if (checkEU === false) {
          setCheckEU(true);
        }
      }).catch((err) => {
        console.log(err);
      });
    }
  }, [airport.code, checkEU]);

  return (
    <div className={styles.advisories}>
      <header>Airport Information</header>
      <div className={styles.list} style={{ overflow: 'auto', height: 'calc(100% - 50px)' }}>
        <div className={styles.head} style={{ overflow: 'auto', height: '100%' }}>
          <div className={styles.Airportcontent} style={{ overflow: 'auto', height: '100%', padding: '10px' }}>
            <Spinner large active={loading} />
            {airportInfo && (
            <div className={styles.RTE} dangerouslySetInnerHTML={{ __html: airportInfo }} />
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = state => ({
  airportInfo: state.airfields.airportInfo
});


const mapDispatchToProps = dispatch => ({
  actionSaveAirportInfo: (data) => {
    dispatch(fetchAirportInfo(data));
  },
  actionSaveRunwayInfo: (data) => {
    dispatch(fetchRunwayInfo(data));
  },
  actionSaveUsefulLinks: (data) => {
    dispatch(fetchUsefulLinks(data));
  }
});

export default connect(mapStateToProps, mapDispatchToProps)(Advisories);
